import { create } from 'zustand';

interface OverlayState {
	isSidebarOpen: boolean;
	isFilterOpen: boolean;
	isSortOpen: boolean;
	toggleSidebar: () => void;
	toggleFilter: () => void;
	toggleSort: () => void;
	closeSidebar: () => void;
	closeFilter: () => void;
	closeSort: () => void;
	closeOverlay: () => void;
}

export const useOverlayStore = create<OverlayState>((set) => ({
	isSidebarOpen: false,
	isFilterOpen: false,
	isSortOpen: false,

	toggleSidebar: (): void => set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),

	toggleFilter: (): void => set((state) => ({ isFilterOpen: !state.isFilterOpen })),

	toggleSort: (): void => set((state) => ({ isSortOpen: !state.isSortOpen })),

	closeSidebar: (): void => set({ isSidebarOpen: false }),

	closeFilter: (): void => set({ isFilterOpen: false }),

	closeSort: (): void => set({ isSortOpen: false }),

	closeOverlay: (): void => set({ isSidebarOpen: false, isFilterOpen: false, isSortOpen: false }),
}));
